import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { Pallets } from '../../../../../modules/API/Pallets/pallets'
import { ILocationForPallet } from '../../../../../modules/API/Pallets/models/locations'
import { LOAD, LOAD_END } from '../../../../../../store/actions/actionsTypes'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'
import usePalletLookup from '../../Pallets/shared/hooks/usePalletLookup'
import { buildLocationPayload } from '../../Pallets/shared/helpers/palletPayloads'

/** Business logic for the pallet/location screen: find a pallet, pick a location, update it. */
const usePalletLocation = () => {
  const dispatch = useDispatch()
  const lookup = usePalletLookup()
  const { data: locations } = useDataFetcher<ILocationForPallet[]>(Pallets.getPalletLocations, 'data')
  const [selectedLocation, setSelectedLocation] = useState<ILocationForPallet | null>(null)

  const submit = useCallback(async () => {
    if (!lookup.palletFound || !selectedLocation) return
    dispatch({ type: LOAD })
    try {
      await Pallets.putPalletLocation(
        buildLocationPayload(lookup.palletFound, selectedLocation.Code, lookup.isExternal),
      )
      handleNotifications('איתור נוסף בהצלחה', { type: 'success' })
      setSelectedLocation(null)
      lookup.reset()
    } catch (error) {
      handleNotifications('משהו השתבש', { type: 'error' })
    } finally {
      dispatch({ type: LOAD_END })
    }
  }, [lookup, selectedLocation, dispatch])

  return {
    ...lookup,
    locations: locations ?? [],
    selectedLocation,
    setSelectedLocation,
    submit,
    canSubmit: !!lookup.palletFound && !!selectedLocation,
  }
}

export default usePalletLocation
